// extracted by mini-css-extract-plugin
export var button = "_jz-0";